import * as React from 'react';
import { Button, UIHeading5 } from '@cian/ui-kit';
import { IconActionPlus16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';

import { trackAddNewBuildingCompareEvent } from '../../tracking';
import * as style from './style.css';
import frame from '../../../../assets/Frame.svg';

const ADD_NEW_BUILDING_TO_COMPARE = '/novostroyki/';

export interface IAddButtonProps {
  floating?: boolean;
}

export const AddButton: React.FC<IAddButtonProps> = ({ floating = false }) => {
  const handleClick = React.useCallback(() => {
    trackAddNewBuildingCompareEvent();
  }, []);

  return (
    <div
      className={clsx(style['container'], floating && style['container-floating'])}
      data-testid="add-newbuildings-button"
    >
      <a
        className={style['link-area']}
        href={ADD_NEW_BUILDING_TO_COMPARE}
        onClick={handleClick}
        rel="noreferrer"
        target="_blank"
      />
      {floating ? (
        <div className={style['add-button-floating-container']}>
          <Button beforeIcon={<IconActionPlus16 color="current_color" />} size="XS" theme="main_secondary" />
          <UIHeading5 color="text-main-default">Найти ещё</UIHeading5>
        </div>
      ) : (
        <img alt="" src={frame} className={style['custom-button-add']} />
      )}
      {!floating && <UIHeading5 color="text-main-default">Найти ещё</UIHeading5>}
    </div>
  );
};
